import { useRSStore } from '../store/useRSStore'
import { readPkgListAPI,addpkgAPI,updatepkgAPI,deletepkgAPI, paginationpkgAPI } from '../api/PkgAPI'

import type { pkg ,pkgfilter,addpkg} from '../types/types'


export function usePkg() {
  const RSStore = useRSStore()

  const onReadPkgList = async (pkgfilter: pkgfilter) => {
    try {
      const list = await readPkgListAPI(pkgfilter)
      RSStore.pkgList = list
    } catch (e) {
      console.error("pkg 데이터를 가져오는 중 에러 발생:", e)
    }
  }

  const onAddPkg = async (addpkg: addpkg) => {
    try {
      const result = await addpkgAPI(addpkg)
      console.log("새 패키지 추가 성공, ID:", result)
    } catch (e) {
      console.error("패키지 추가 중 에러 발생:", e)
    }
  }

  const onUpdatePkg = async (updatedPkg: pkg) => {
    try {
      const result = await updatepkgAPI(updatedPkg)
      if (result) {
        console.log("패키지 업데이트 성공")

      } else {
        console.error("패키지 업데이트 실패")
      }
    } catch (e) {
      console.error("패키지 업데이트 중 에러 발생:", e)
    }
  }

  const onDeletePkg = async (id: number) => {
    try {
      const result = await deletepkgAPI(id)
      if (result) {
        console.log("패키지 삭제 성공")
      } else {
        console.error("패키지 삭제 실패")
      }
    } catch (e) {
      console.error("패키지 삭제 중 에러 발생:", e)
    }
  }

    const onPaginationPkg = async (pkgfilter: pkgfilter) => {
      try {
        const result = await paginationpkgAPI(pkgfilter) ?? 0
        return result
      } catch (e) {
        console.error("패키지 페이지네이션 가져오는 중 에러 발생:", e)
      }
    }
  
  return {
    onReadPkgList,
    onAddPkg,
    onUpdatePkg,
    onDeletePkg,
    onPaginationPkg
  }
}